import axios from "axios"
import baseUrl from "./base"

const pendudukApi = {
  fetchPenduduk: async (token, data) => {
    return await axios.get(`${baseUrl}/api/penduduk/get`,
      { params: data, headers: { Authorization: `Bearer ${token}` } }
    )
  },
  fetchAnggotaKkPenduduk: async (token, no_kk) => {
    return await axios.get(`${baseUrl}/api/penduduk/${no_kk}/getKk`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  storePenduduk: async (token, data) => {
    return await axios.post(`${baseUrl}/api/penduduk/store`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  updatePenduduk: async (token, id, data) => {
    return await axios.post(`${baseUrl}/api/penduduk/${id}/update`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  hapusPenduduk: async (token, id) => {
    return await axios.delete(`${baseUrl}/api/penduduk/${id}/destroy`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  updateProfilePenduduk: async (token, data) => {
    return await axios.post(`${baseUrl}/api/penduduk/updateProfile`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  searchPenduduk: async (q, token) => {
    return await axios.get(`${baseUrl}/api/penduduk/search?q=${q}`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  fetchRiwayatImportPenduduk: async (token) => {
    return await axios.get(`${baseUrl}/api/import/penduduk/getRiwayatImport`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  sinkronisasiPenduduk: async (token, id, data) => {
    return await axios.post(`${baseUrl}/api/import/penduduk/sinkronisasi/${id}`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  cekDataImportPenduduk: async (token, data, uploadProgress) => {
    return await axios.post(`${baseUrl}/api/import/penduduk/cekData`, data,
      { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" }, onUploadProgress: uploadProgress }
    )
  },
  showSelfieKtp: async (token, id) => {
    return await axios.get(`${baseUrl}/api/berkasPendaftaran/showSelfieKtp?id_penduduk=${id}`,
      { headers: { Authorization: `Bearer ${token}` }, responseType: 'arraybuffer' }
    )
  }
}

export default pendudukApi